const Onboarding = {
  namespaced: true,
  state: {
    tutorials: [],
    isOpen: false,
    isForced: false,
    activeOnboardingId: null
  },
  mutations: {
    SET_TUTORIALS(state: Record<string, any>, tutorials: any[]) {
      state.tutorials = tutorials;
    },
    SET_OPEN(state: Record<string, any>, isOpen: boolean) {
      state.isOpen = isOpen;
    },
    TOGGLE_OPEN(state: Record<string, any>) {
      state.isOpen = !state.isOpen;
    },
    SET_FORCED(state: Record<string, any>, isForced: boolean) {
      state.isForced = isForced;
    },
    SET_ACTIVE_ID(state: Record<string, any>, id: number | null) {
      state.activeOnboardingId = id;
    }
  },
  actions: {
    setPageTutorials({ commit }: any, tutorials: any[]) {
      commit('SET_TUTORIALS', tutorials);
    },
    clearTutorials({ commit }: any) {
      commit('SET_TUTORIALS', []);
      commit('SET_OPEN', false);
      commit('SET_FORCED', false);
    },
    toggle({ commit }: any) {
      commit('TOGGLE_OPEN');
    },
    open({ commit }: any) {
      commit('SET_OPEN', true);
    },
    close({ commit }: any) {
      commit('SET_OPEN', false);
      commit('SET_FORCED', false);
      commit('SET_ACTIVE_ID', null);
    },
    forceOpen({ commit }: any, id: number) {
      commit('SET_OPEN', true);
      commit('SET_FORCED', true);
      commit('SET_ACTIVE_ID', id);
    }
  },
  getters: {
    hasOnboarding: (state: Record<string, any>) => state.tutorials.length > 0,
    tutorials: (state: Record<string, any>) => state.tutorials,
    isOpen: (state: Record<string, any>) => state.isOpen,
    isForced: (state: Record<string, any>) => state.isForced,
    activeOnboardingId: (state: Record<string, any>) => state.activeOnboardingId
  }
};

export default Onboarding;
